@use "ui/styles/fontsOld";

.wrapper {
  position: relative;

  .question {
    font-weight: fontsOld.$medium-weight;
    margin-bottom: 16px;
  }

  .message {
    color: var(--text-secondary);
    line-height: 1.5;
  }
}

